import * as React from 'react';

import { Celula } from '@/componentes/celula';

/* As duas peças de que todo capítulo desta página é feito: a célula com
 * título e a linha rótulo/valor.
 *
 * São compartilhadas porque sete capítulos as diriam iguais, e o primeiro a
 * mudar de geometria sozinho seria o começo da divergência. */

export function Capitulo({
  titulo,
  descricao,
  children,
}: {
  titulo: string;
  descricao?: string | undefined;
  children: React.ReactNode;
}) {
  return (
    <Celula como="section" className="grid gap-3">
      <div className="grid gap-1">
        <h2 className="titulo-bloco">{titulo}</h2>
        {descricao ? <p className="text-tinta-2 text-apoio">{descricao}</p> : null}
      </div>
      {children}
    </Celula>
  );
}

export function Linha({ rotulo, children }: { rotulo: string; children: React.ReactNode }) {
  return (
    <div className="border-fio grid grid-cols-[10rem_1fr] gap-3 border-b py-2 last:border-b-0">
      <span className="text-tinta-2 text-nota">{rotulo}</span>
      <span className="text-apoio min-w-0 break-words">{children}</span>
    </div>
  );
}

/** O capítulo que a empresa não preencheu. Diz qual etapa preenche. */
export function NaoPreenchido({ children }: { children: React.ReactNode }) {
  return <p className="text-tinta-2 text-apoio">{children}</p>;
}
